import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export class LU_QM_SpecificationCategory extends StarbaseEntity implements Serializable<LU_QM_SpecificationCategory> {
    public specificationCategory: string;
    public uid: number;
    public editable: boolean; // TODO: do we need this here? Isn't this a part of IColumnModel?

    constructor() {
        super();
    }

    public static LU_QM_SpecificationCategoryColumnData(editable: boolean = false): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false),
            new ColumnModel('Specification Category', 'specificationCategory', 'specificationCategoryspecificationCategory', editable, 'string', false, true, 255, true),
            new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, true, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 100, false)
        ];
    }

    public static CreateLuQmSourceReferenceColumnData(): IColumnModel[] {
        return [
            new ColumnModel('Specification Category', 'specificationCategory', 'specificationCategory', true, 'string', false, true, 255, true)
        ];
    }

    public static setupPrimaryWeaponCollection(collection: LU_QM_SpecificationCategory[]): void {
        of(collection).pipe(
            map((w: LU_QM_SpecificationCategory[]) =>
                w.map((k: LU_QM_SpecificationCategory) => {
                    k = new LU_QM_SpecificationCategory().deserialize(k);
                })
            )
        ).subscribe();
    }

    deserialize(input) {
        return Object.assign(new LU_QM_SpecificationCategory(), input);
    }
}
